/****************************************************************************
 * Copyright 2018 EPAM Systems
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 ***************************************************************************/
import closestToSel from './utils/closestToSel'
let timerId = 0
function AbbrTool(editor) {
  if (!(this instanceof AbbrTool)) {
    return new AbbrTool(editor)
  }
  //如果当前没有选中元素,则进入选择模式
  if (editor.selection() && editor.selection().atoms) {
    if (timerId) {
      clearTimeout(timerId)
    }
    timerId = setTimeout(() => {
      const ra = editor.event.openDialog.dispatch('abbrLib')
      Promise.resolve(ra).catch(() => null) // w/o changes
    }, 100)
  }
  this.editor = editor
  // this.editor.selection(null);
}

AbbrTool.prototype.mousemove = function (event) {
  this.editor.hover(this.editor.findItem(event, ['atoms']))
}
AbbrTool.prototype.click = function (event) {
  var editor = this.editor
  var ci = editor.findItem(event, ['atoms'])
  if (ci && ci.map === 'atoms') {
    let sel = closestToSel(ci)
    this.editor.hover(null)
    this.editor.selection(sel)
    const ra = editor.event.openDialog.dispatch('abbrLib')
    Promise.resolve(ra).catch(() => null) // w/o changes
  }
  return true
}

export default AbbrTool
